import React from 'react';
import { Button } from './ui/button';

export const EmptyState = ({ icon: Icon, title, hint, actionLabel, onAction, testId = 'empty-state' }) => (
  <div data-testid={testId} className="rounded-2xl border border-dashed border-[hsl(var(--border))] bg-white/60 p-8 text-center">
    {Icon && <Icon className="h-8 w-8 mx-auto text-[hsl(var(--muted-foreground))] opacity-60" />}
    <p className="mt-3 font-medium">{title}</p>
    {hint && <p className="mt-1 text-sm text-[hsl(var(--muted-foreground))]">{hint}</p>}
    {actionLabel && (
      <Button data-testid={`${testId}-action`} className="mt-4 h-11 rounded-xl" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </div>
);
